/* export default {
  baseURL: process.env.REACT_APP_API_URL || '',
};
 */

export default {
  baseURL: process.env.REACT_APP_API_URL || 'https://trello-back.shpp.me/tburia/api/v1',
};
